var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 569.08 368.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#592775;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.78,365.72S-24.52,31.83,212.48,39.83C299.4,42.76,358.86,34,399.32,21.75c69.06-20.93,123.34,61,76.24,115.72-32.68,37.95-99.44,66.29-228,62.82a169.8,169.8,0,0,1-19.88-1.71C198,194.24,76.9,188.63.78,365.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.1,150.82s128.85,70,103.73,202.24a19.08,19.08,0,0,1-18.76,15.47H525.32s5.62-115.06-100.61-194.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.78,365.72l28.24.39s21.62-96.7,73-135l-65.58-5.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M484.42,125.74s63.23,53.79,73.65,133.94-73.65-67-73.65-67l-42-41.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.7,159.83l38.75-88A120.26,120.26,0,0,1,180.52,0H384.35A120.25,120.25,0,0,1,498.5,82.41l66.72,201.17L414.36,159.83l-212.3-25.66L66,204.66,21.11,215.38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset14);
export default __webpack_public_path__ + "static/media/Asset 14.83fd705d.svg";
export { ForwardRef as ReactComponent };